var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.27267C9.27668 7.27267 8.58299 7.56001 8.07153 8.07147C7.56006 8.58293 7.27273 9.27663 7.27273 9.99994C7.27273 10.7233 7.56006 11.417 8.07153 11.9284C8.58299 12.4399 9.27668 12.7272 10 12.7272C10.7233 12.7272 11.417 12.4399 11.9285 11.9284C12.4399 11.417 12.7273 10.7233 12.7273 9.99994C12.7273 9.27663 12.4399 8.58293 11.9285 8.07147C11.417 7.56001 10.7233 7.27267 10 7.27267ZM10 14.5454C8.79447 14.5454 7.63832 14.0665 6.78588 13.2141C5.93344 12.3616 5.45455 11.2055 5.45455 9.99994C5.45455 8.79441 5.93344 7.63826 6.78588 6.78582C7.63832 5.93338 8.79447 5.45449 10 5.45449C11.2055 5.45449 12.3617 5.93338 13.2141 6.78582C14.0666 7.63826 14.5455 8.79441 14.5455 9.99994C14.5455 11.2055 14.0666 12.3616 13.2141 13.2141C12.3617 14.0665 11.2055 14.5454 10 14.5454ZM10 3.18176C5.45455 3.18176 1.57273 6.00904 0 9.99994C1.57273 13.9909 5.45455 16.8181 10 16.8181C14.5455 16.8181 18.4273 13.9909 20 9.99994C18.4273 6.00904 14.5455 3.18176 10 3.18176Z",
    fill: "#5F6368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.ae6af0ffb10c1519a24dbd9d7e735527.svg";
export { ForwardRef as ReactComponent };